/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difference_Heading_1Inputs */

const et_difference_heading_1 = /** @type {(inputs: Difference_Heading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suur`)
};

const en_difference_heading_1 = /** @type {(inputs: Difference_Heading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Major`)
};

/**
* | output |
* | --- |
* | "A Major" |
*
* @param {Difference_Heading_1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const difference_heading_1 = /** @type {((inputs?: Difference_Heading_1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difference_Heading_1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_difference_heading_1(inputs)
	return en_difference_heading_1(inputs)
});